import Templater from '@hc-frontend/shared-assets/src/js/utils/dom/Templater'
import renderPlans from './components/comparePlans/renderPlans'
import getById from 'utils/DOM/getById'
import hasSomePlanByType from 'utils/pivot/plan/hasSomePlanByType'
import {
  CHOICE,
  CORE,
  DELUXE,
  ECONOMY,
  EPIC,
  QUANTUM,
  STANDARD,
  SURE_CARE
} from 'core/constants/products'
import isCignaPlan from 'utils/pivot/plan/isCignaPlan'
import toggleClass from 'utils/DOM/toggleClass'
import isPlanPPO from 'utils/pivot/plan/isPlanPPO'
import sortTable from './controller/sort-table'

const templatePlan = Templater(getById('template-plan-card').innerText)
const plansWrap = getById('compare-plans')

function updateDisclaimers({ plansData, plans }) {
  const hasCignaPlan =
    Object.keys(plansData).filter(planKey => isCignaPlan(plansData[planKey])).length > 0

  const plansByType = {}
  Object.keys(plansData).forEach(planKey => {
    const { productId, planId } = plansData[planKey]
    const types = plansByType[productId] || []
    plansByType[productId] = [...types, planId]
  })

  toggleClass('body', 'cigna', hasCignaPlan)

  const plansHaveEpic = hasSomePlanByType([EPIC], plansByType)
  toggleClass(document.body, 'nric', plansHaveEpic)

  const plansHaveEpicPPO =
    Object.keys(plansData).filter(planKey => isPlanPPO(plansData[planKey])).length > 0

  toggleClass(document.body, 'nric-ppo', plansHaveEpic && plansHaveEpicPPO)

  const hasCLICPlan = hasSomePlanByType(
    [ECONOMY, QUANTUM, DELUXE, STANDARD, CORE, CHOICE],
    plansByType
  )
  toggleClass(document.body, 'clic', hasCLICPlan)

  const hasSureCarePlan = hasSomePlanByType([SURE_CARE], plansByType)
  toggleClass(document.body, 'sure_care', hasSureCarePlan)
}

function updateDOM(state: ComparePage.State) {
  if (Object.keys(state.plans).length === 0) {
    return undefined
  }
  const { plans, plansData } = state
  updateDisclaimers({ plans, plansData })
  renderPlans(plansWrap, templatePlan, state).then(sortTable)
}

export default updateDOM
